import { FormProvider, useForm } from "react-hook-form";
import { ThemeProvider } from "@emotion/react";
import { createTheme, Box, CircularProgress } from "@mui/material";
import { usePeMappingContext } from "../../helper";
import { defaultFormTheme } from "../../../../../atoms/defaultFormTheme";
import InviteExpertFields from "./fields";
import { defaultValues } from "./helper";
import { useProjectAgendaItems } from "./useProjectAgendaItems";
import { TInviteExpertForm } from "./type";



const InviteExpertForm = ({
  pe_id,
  project_id,
  renderSubmitAndCloseComponent,
  submitHandler
}: TInviteExpertForm) => {
  const { refetch } = usePeMappingContext();
  const methods = useForm({ defaultValues });

  const defaultTheme = createTheme(defaultFormTheme);

  const { agendas, loading: agendaLoading, error: agendaError } = useProjectAgendaItems(Number(project_id), Number(pe_id));

  const sendInviteValue = methods.watch("send_invite");
  const shareAgendaValue = methods.watch("share_agenda");
  const selectedAgendasValue = methods.watch("selected_agendas");


  if (agendaLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", margin: "10px" }}>
        <CircularProgress />
      </Box>
    );

  }
  return (
    <FormProvider {...methods}>
      <ThemeProvider theme={defaultTheme}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <form onSubmit={methods.handleSubmit(() => submitHandler({sendInviteValue, shareAgendaValue, selectedAgendasValue, refetch}))} noValidate>
            {project_id && (
              <InviteExpertFields
                agendas={agendas}
                agendaError={agendaError}
              />
            )}
            {renderSubmitAndCloseComponent()}
          </form>
        </Box>
      </ThemeProvider>
    </FormProvider>
  );
};

export default InviteExpertForm;
